import {initRewardBenefitByAPI} from '@web/actions/detail'
import makeSlice from '@web/slices/purchaser/sliceMaker'

const purchaserSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initRewardBenefitByAPI.fulfilled, (state, {payload}) => {
            state.naverMembership.subscribed = payload.expectNaverMembership?.subscribed ?? false
        })
    },
})

export default purchaserSlice.reducer
